import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../../common/breadcrumbs";
import { SWAL_SETTINGS, INPUT_LENGTH_500 } from "../../../../../../utils/Constants";
import {
    globalLoader,
    handleServerValidations,
} from "../../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import CustomCkeditor from "../../../../common/customeditor";
import { AddCenterService } from "../../../../services/usermgmt.services";

const CenterServiceAdd = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { t } = useTranslation()
    const [submitted, setSubmitted] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [previewimage, setPreviewImage] = useState("");
    const [initialValues, setInitialValues] = useState({
        title: "",
        description: "",
        image: "",
    });

    const breadcrumbs = [
        { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
        {
        title: t("Center Management"),
        url: "/admin/center-management/center/list/1",
        },
        {
        title: "Center Services",
        url: `/admin/center-management/center/service/${params.center_id}/list/1`,
        },
        { title: t("admin.faq.link_add"), url: "" },
    ];

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {/* {dataLoaded ? ( */}
            <Formik
                initialValues={{
                title: "",
                description: "",
                image: "",
            }}
            validateOnBlur={false}
            validate={(values) => {
                const error = {};
                const MAX_IMAGE_SIZE_MB = 5;
                const allowedImageTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];

                if (!values.title || !values.title.trim()) {
                    error.title = "admin.faq.label_title_error";
                } else if (values.title.length > INPUT_LENGTH_500) {
                    error.title = "admin.faq.validation_err_reached_maximum_length";
                }

                if (!values.description || !values.description.trim()) {
                    error.description = "admin.faq.label_description_error";
                }

                if (!values.image) {
                    error.image = "Please upload an image.";
                } else {
                    if (!allowedImageTypes.includes(values.image.type)) {
                        error.image = "Invalid image format. Only JPEG, PNG, WEBP, or GIF allowed.";
                    }
                    const fileSizeMB = values.image.size / (1024 * 1024);
                    if (fileSizeMB > MAX_IMAGE_SIZE_MB) {
                        error.image = `Image size should not exceed ${MAX_IMAGE_SIZE_MB}MB.`;
                    }
                }

                return error;
            }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    setSubmitted(true);
                    globalLoader(true);
                    console.log(values);
                    let formData = new FormData();
                    formData.append("center_id", params.center_id);
                    formData.append("title", values.title);
                    formData.append("description", values.description);
                    if (values.image) {
                        formData.append("image", values.image);
                    }
                    AddCenterService(formData)
                        .then((response) => {
                            setSubmitting(false);
                            if (response.success) {
                                Swal.fire({
                                    icon: "success",
                                    text: response.message,
                                    ...SWAL_SETTINGS,
                                });
                                setTimeout(() => {
                                    resetForm({ values: "" });
                                    globalLoader(false);
                                    navigate(`/admin/center-management/center/service/${params.center_id}/list/1`);
                                }, 1000);
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: handleServerValidations(response),
                                    ...SWAL_SETTINGS,
                                });
                                setSubmitted(false);
                                globalLoader(false);
                            }
                        })
                        .catch((error) => {
                            console.log("error ====> ", error);
                        });
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row row-sm">
                            <div className="col-lg-12 col-md-12 animation_fade">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div>
                                            <h6 className="main-content-label mb-3">Add Center Service</h6>
                                        </div>
                                        <div className="row row-sm">

                                            <div className="col-lg-6 text-center form-group">
                                                <label htmlFor="title" className="text-left d-flex">
                                                    {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                                                </label>
                                                <input
                                                    name="title"
                                                    id="title"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.title}
                                                    className="form-control"
                                                    placeholder={t("Enter title")}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.title && touched.title && t(errors.title)}
                                                </span>
                                            </div>
                                            <div className="col-lg-12 text-center form-group">
                                                <label htmlFor="description" className="text-left d-flex">
                                                    {t("admin.faq.label_description")}:<span className="requirestar">*</span>
                                                </label>
                                                <CustomCkeditor
                                                    fieldname={"description"}
                                                    setFieldValue={setFieldValue}
                                                    value={values.description}
                                                    setFieldTouched={setFieldTouched}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.description &&
                                                        touched.description &&
                                                        t(errors.description)}
                                                </span>
                                            </div>
                                            <div className="col-lg-12 text-center form-group">
                                                <label htmlFor="image" className="text-left d-flex">
                                                    Upload Image:
                                                    {/* <small className="text-muted d-block mt-1 ms-2">
                                                        Please upload an image in{" "}
                                                        ({" "}
                                                        <code>
                                                            {2288}px width × {934}px height
                                                        </code>
                                                        ).
                                                    </small> */}
                                                </label>
                                                <input
                                                    className="form-control imgInput"
                                                    id="image"
                                                    name="image"
                                                    accept="image/*"
                                                    type="file"
                                                    onChange={(event) => {
                                                        setFieldValue(
                                                            "image",
                                                            event.target.files[0] || ""
                                                        );
                                                        event.target.files.length === 1
                                                            ? setPreviewImage(
                                                                URL.createObjectURL(event.target.files[0])
                                                            )
                                                            : setPreviewImage("");
                                                    }}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.image && touched.image && t(errors.image)}
                                                </span>
                                                {previewimage ? (
                                                    <ul className="question-image-preview questions-ul">
                                                        <li className="pr_img_box">
                                                            <img
                                                                src={previewimage}
                                                                style={{ height: "100px" }}
                                                                alt={"banner-image"}
                                                            />
                                                            <div className="img_options">
                                                                <button type="button" className="text-danger"
                                                                    onClick={() => {
                                                                        setPreviewImage("");
                                                                        setFieldValue("image", null);
                                                                        document.getElementById("image").value = ""
                                                                    }}>
                                                                    <i className="ri-delete-bin-6-fill"></i>
                                                                </button>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            <div className="">
                                                <button
                                                    className="btn btn-main-primary signbtn mr-2"
                                                    type="submit"
                                                    disabled={submitted ? true : null}
                                                >
                                                    <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                    {t("admin.button.btn_submit")}
                                                </button>
                                                <button
                                                    className="btn ripple btn-secondary"
                                                    type="button"
                                                    disabled={submitted ? true : null}
                                                    onClick={() => navigate(-1)}
                                                >
                                                    <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                    {t("admin.button.btn_cancel")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
            {/* ) : (
                <></>
            )} */}
        </>
    );
};

export default CenterServiceAdd;
